import { create } from 'zustand'
import { persist } from 'zustand/middleware'

type Theme = 'light' | 'dark'

type ThemeState = {
  theme: Theme
  setTheme: (theme: Theme) => void
  toggle: () => void
}

function applyThemeClass(theme: Theme) {
  document.documentElement.classList.toggle('dark', theme === 'dark')
}

function initialTheme(): Theme {
  // Light-first per master plan: default to light regardless of OS preference.
  return 'light'
}

/**
 * Persisted light/dark theme (Phase 0 design foundation). Applies the
 * `dark` class to <html> so Tailwind's `dark:` variants take effect;
 * defaults to the OS preference on first load, then remembers the user's
 * explicit choice.
 */
export const useThemeStore = create<ThemeState>()(
  persist(
    (set, get) => ({
      theme: initialTheme(),
      setTheme: (theme) => {
        applyThemeClass(theme)
        set({ theme })
      },
      toggle: () => get().setTheme(get().theme === 'dark' ? 'light' : 'dark'),
    }),
    {
      name: 'cgp.theme',
      onRehydrateStorage: () => (state) => {
        if (state) applyThemeClass(state.theme)
      },
    },
  ),
)

// Apply immediately on module load so there is no flash of the wrong theme.
if (typeof document !== 'undefined') {
  applyThemeClass(useThemeStore.getState().theme)
}
